import React from 'react';
import { Trans } from 'react-i18next';
import { connect } from 'react-redux';

import { toggleChat } from 'apps/auth/actions/chatAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { HELP, LOGIN } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { getErrorReportFields } from 'apps/auth/helpers/errorReport';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            errorInfo: null,
        };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo,
        });
        this.sendErrorsToServer(error, errorInfo);
    }

    sendErrorsToServer(error, errorInfo) {
        apiFetchData('/exception', getErrorReportFields(error, errorInfo?.componentStack)).catch(() => {});
    }
    openChat = () => {
        this.props.toggleChat(true);
    };

    render() {
        if (this.state.errorInfo) {
            return (
                <InfoPage
                    animatedIconFail
                    headerText={<Trans>ps.500.title</Trans>}
                    secondaryText={<Trans>ps.404.error.description</Trans>}
                    buttonRowType="link"
                    backUrl={LOGIN}
                    leftCloseIcon
                    isTagA
                    buttonRowCaption={<Trans>ps.404.help</Trans>}
                    buttonRowHref={HELP}
                    primaryButtonCaption={<Trans>ps.404.chat.button</Trans>}
                    primaryButtonOnClick={this.openChat}
                />
            );
        }
        return this.props.children;
    }
}

export default connect(null, { toggleChat })(ErrorBoundary);
